// const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const DOMAIN = "http://165.22.208.89:8070";
export const DOMAIN = "https://adsone.lk";
export const BASE_URL = `${DOMAIN}/api/v1`;

export const API_ROUTES = {
  AUTH: `/user`,
  ADMIN: `/admin`,
  MAIN: `/classified`,
  SELLER: `/seller`,
};
